export default __webpack_public_path__ + "static/media/photo2.90a9cf9b.jpg";